import { render } from "./StudioManage.vue?vue&type=template&id=20991842"
import script from "./StudioManage.vue?vue&type=script&lang=js"
export * from "./StudioManage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__